import { HoursAndDateOverrides } from './components'
import { PanelContentContainer } from '../../styles'


export const EventTypeLevelAvailableHours = ({
  formPath,
  isManaged = false,
  fixTimezonePositioning = false,
  readOnly = false,
}) => (
  <PanelContentContainer>
    <HoursAndDateOverrides
      isManaged={isManaged}
      formPath={formPath}
      fixTimezonePositioning={fixTimezonePositioning}
      readOnly={readOnly}
    />
  </PanelContentContainer>
)
